import appStore from 'store';
import api from './api';

const store = {
    namespaced: true,
    state :{
        NetValueTotal:0,
        NetValueInfo:[],
    },
    mutations:{
        setNetValueListTotal(state,payload){
           state.NetValueTotal = payload;
        },
        setNetValueListInfo(state,payload){
            state.NetValueInfo = payload;
        },
    },
    actions:{
        getNetValueList({commit},data){
            api.getNetValueList(data).then(response => {
                console.log(response)
                commit('setNetValueListTotal',response.data.totalCount);
                commit('setNetValueListInfo',response.data.list);
            })
        },
    }
}

appStore.registerModule('RaiseFunds', store);